import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { defineMessages, useIntl } from 'react-intl';
import { useParams } from 'react-router';
import styled from 'styled-components';

import { PageHeader } from '@sorare/core/src/components/navigation/PageHeader';
import { useQuery } from '@sorare/core/src/hooks/graphql/useQuery';

import { AppLayout } from '@sorare/gameplay/src/components/navigation/AppLayout';
import { Network } from '@sorare/gameplay/src/components/network/Network';

import type {
  NetworkUserQuery,
  NetworkUserQueryVariables,
} from './__generated__/index.graphql';

const messages = defineMessages({
  friends: {
    id: 'Network.friends',
    defaultMessage: 'Friends',
  },
});

const Root = styled.div`
  padding: var(--double-unit);
`;

const NETWORK_USER_QUERY = gql`
  query NetworkUserQuery($slug: String!) {
    user(slug: $slug) {
      id
      slug
      ...Network_user
    }
  }
  ${Network.fragments.user}
` as TypedDocumentNode<NetworkUserQuery, NetworkUserQueryVariables>;

export const NetworkPage = () => {
  const { formatMessage } = useIntl();
  const { slug } = useParams();

  const { data } = useQuery(NETWORK_USER_QUERY, {
    variables: { slug: slug || '' },
    skip: !slug,
  });

  if (!data?.user) return null;

  return (
    <AppLayout>
      <PageHeader text={formatMessage(messages.friends)} />
      <Root>
        <Network user={data?.user} />
      </Root>
    </AppLayout>
  );
};
